const css = `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.repo-card-div {
  color: rgb(88, 96, 105);
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 10px 30px -15px;
  padding: 2rem;
  cursor: pointer;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.repo-card-div:hover {
  box-shadow: rgba(0, 0, 0, 0.2) 0px 20px 30px -10px;
}

.repo-stats {
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  font-size: 13px;
  color: rgb(106, 115, 125);
}

.repo-left-stat {
  -webkit-box-flex: 1;
  flex-grow: 1;
  display: flex;
}

.language-color {
  width: 10px;
  height: 10px;
  background-color: #0000ff;
  margin-right: 0.25rem;
  border-radius: 100%;
}

.repo-left-stat span {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  margin-right: 0.75rem;
}

.repo-name-div {
  display: flex;
  align-items: center;
}

.repo-svg {
  margin-right: 0.5rem;
  min-width: 16px;
}

.repo-name {
  white-space: nowrap;
  text-overflow: ellipsis;
  color: rgb(36, 41, 46);
  margin-bottom: 0.75rem;
  font-size: 25px;
  font-weight: 700;
  letter-spacing: -0.5px;
  overflow: hidden;
  margin: 0px;
  height: 30px;
}

.repo-star-svg {
  margin-right: 0.3rem;
}

.repo-description {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.dark-card-mode {
  background-color: #171c28;
  color: #ffffff;
}

.dark-card-mode p {
  color: #ffffff;
}

.dark-card-mode .repo-svg {
  fill: #ffffff;
}

.dark-card-mode:hover {
  background-color: #55198b !important;
  box-shadow: 0px 0px 16px #d9dbdf;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
